import { useCallback, useContext, useMemo } from 'react';
import { ProductTableContext } from '../../../contexts/product-table-context';
import { type SaleStatDays, saleStatDays } from '../../../data/product';
import type { Filters } from '../../../hooks/products';
import { Select } from '../../forms';
import { withFilterField } from './filter-component';
import { FilterWrapper } from './filter-wrapper';

export function toSoldInOptions(days: SaleStatDays[]) {
  return days.map((d) => ({ value: d, label: `${d} days` }));
}

export const SoldInFilter = withFilterField(
  'soldIn',
  function SoldInFilter({ overrideSoldInDays }: { overrideSoldInDays?: SaleStatDays[] }) {
    const { filters, setFilters } = useContext(ProductTableContext);
    const { soldIn } = filters;

    const soldInDays = useMemo(() => {
      if (overrideSoldInDays) {
        return overrideSoldInDays;
      }

      return [...saleStatDays];
    }, [overrideSoldInDays]);

    const onChange = useCallback(
      (next: SaleStatDays) => {
        setFilters((prev: Filters) => ({ ...prev, soldIn: next }));
      },
      [setFilters]
    );

    const options = useMemo(() => toSoldInOptions(soldInDays), [soldInDays]);

    return (
      <FilterWrapper label="Sold In Last">
        <Select<SaleStatDays>
          value={soldIn ?? soldInDays[0]}
          onChange={onChange}
          options={options}
        />
      </FilterWrapper>
    );
  }
);
